import { PriorityModalContext } from "contexts/PriorityModalContext"
import { useContext, useState } from "react"
import { HiOutlinePlus } from "react-icons/hi2";
import { TbDatabaseStar, TbGif, TbSettings } from "react-icons/tb";
import getFileType, { getFileTypeImageVideo } from "utils/fileType";
import useCreativeGenerator from "utils/hooks/useCreativeGenerator";
import usePostValidator, { getNetworkValidationIndex } from "utils/hooks/usePostValidator"
import ExploreMedia from "views/media/ExploreMedia"
import { PLACEMENT } from "components/ui/utils/constant";
import AIImages from "views/company_settings/components/AIImages";
import { RiImageAiLine, RiVideoOnAiLine } from "react-icons/ri";
import AIVideos from "views/ai_video/AIVideoBody";
import AIPriceBadge from "components/shared/AIPriceBadge";
import { AIContext } from "contexts/AIContext";

const { Dropdown, Button, Dialog } = require("components/ui")
const { MdOutlineImageSearch } = require("react-icons/md")

const AddAssetButton = ({
    className = "",
    network = "",
    onAssetNew = undefined,
    onAssetDelete = undefined,
    post = {},
    allPosts = [],
    placement = PLACEMENT.CENTER_CENTER,
    renderTitle = undefined,
    portal = false
}) => {

    const { openModalPriority, closeModalPriority } = useContext(PriorityModalContext);
    const { aiModels } = useContext(AIContext);
    const defaultImageModel = aiModels?.find(m => m.type === 'image' && !m.disabled);
    const defaultVideoModel = aiModels?.find(m => m.type === 'video' && !m.disabled);
    const aiImagePrice = defaultImageModel?.price || 0;
    const aiVideoPrice = defaultVideoModel?.price || 0;
    const { generateAIImageFromCopy, generateStockImageFromCopy, generateStockGIFFromCopy, generateAIVideoFromCopy } = useCreativeGenerator();
    const { validationConstants } = usePostValidator();
    const [ isGenerating, setIsGenerating ] = useState(false);
    const [ selectAssetModalOpened, setSelectAssetModalOpened ] = useState(false);

    const networkValidationIndex = getNetworkValidationIndex(network, post?.preferences?.media_product_type);
    const maxMedia = validationConstants?.[networkValidationIndex]?.media_urls?.max_length;
    const maxImages = validationConstants?.[networkValidationIndex]?.media_urls?.max_images_length;
    const maxVideos = validationConstants?.[networkValidationIndex]?.media_urls?.max_videos_length;
    const maxGifs = validationConstants?.[networkValidationIndex]?.media_urls?.max_gifs_length;
    const oneMediaTypeOrTheOther = !validationConstants?.[networkValidationIndex]?.media_urls?.allow_multiple_types;
    const allowedTypes = [...maxImages > 0 ? ["image"] : [], ...maxVideos > 0 ? ["video"] : [], ...maxGifs > 0 ? ["gif"] : []];

    const canLoadMoreMedia = (assets = undefined) => {
        assets = assets || post?.assets;
        if (!oneMediaTypeOrTheOther) {
            // If there is no media or length is less than Max media
            return assets?.length < (maxMedia ? maxMedia : maxImages + maxVideos + maxGifs) || !assets?.length;
        } else {
            // If has images loaded
            if (assets?.filter(e => getFileType(e?.image?.url || e?.video?.url) == "image")?.length) {
                return assets?.length < (maxImages ? maxImages : maxMedia);
            }
            // If has videos loaded
            if (assets?.filter(e => getFileType(e?.image?.url || e?.video?.url) == "video")?.length) {
                return assets?.length < (maxVideos ? maxVideos : maxMedia);
            }
            // If has gifs loaded
            if (assets?.filter(e => getFileType(e?.image?.url || e?.video?.url) == "gif")?.length) {
                return assets?.length < (maxGifs ? maxGifs : maxMedia);
            }
            // Default true
            return true;
        }
    }

    const getAllowedTypes = () => {
        if (!oneMediaTypeOrTheOther) {
            return allowedTypes;
        } else {
            if (post?.assets?.filter(e => getFileType(e?.image?.url || e?.video?.url) == "image")?.length) {
                return ["image"]
            }
            if (post?.assets?.filter(e => getFileType(e?.image?.url || e?.video?.url) == "video")?.length) {
                return ["video"]
            }
            if (post?.assets?.filter(e => getFileType(e?.image?.url || e?.video?.url) == "gif")?.length) {
                return ["gif"]
            }
            return allowedTypes;
        }
    }

    const handleOnSuggestStockImage = () => {
        setIsGenerating(true);
        generateStockImageFromCopy(network, post?.text, post?.preferences?.media_product_type).then((imageURL) => {
            onAssetNew({
                image: {
                    url: imageURL,
                    thumbnail: {
                        url: imageURL
                    }
                }
            })
        }).finally(() => {
            setIsGenerating(false);
        })
    }

    const handleOnSuggestGIF = () => {
        setIsGenerating(true);
        generateStockGIFFromCopy(network, post?.text, post?.preferences?.media_product_type).then((imageURL) => {
            onAssetNew({
                image: {
                    url: imageURL,
                    thumbnail: {
                        url: imageURL
                    }
                }
            })
        }).finally(() => {
            setIsGenerating(false);
        })
    }

    const handleOnSuggestAIImage = () => {
        setIsGenerating(true);
        generateAIImageFromCopy(network, post?.text, post?.preferences?.media_product_type).then((imageURL) => {
            onAssetNew({
                image: {
                    url: imageURL,
                    thumbnail: {
                        url: imageURL
                    }
                }
            })
        }).finally(() => {
            setIsGenerating(false);
        })
    }

    const handleOnSuggestAIVideo = () => {
        setIsGenerating(true);
        generateAIVideoFromCopy(network, post?.text, post?.preferences?.media_product_type).then((videoURL) => {
            onAssetNew({
                video: {
                    url: videoURL,
                    thumbnail: {
                        url: videoURL
                    }
                }
            })
        }).finally(() => {
            setIsGenerating(false);
        })
    }

    const handleOnSelectAsset = (asset) => {
        asset.id = undefined;
        return onAssetNew(asset);
    }

    const handleOnSelectImage = () => {
        setSelectAssetModalOpened(true);
        // if (!canLoadMoreMedia()) return;
        // openModalPriority(
        //     <ExploreMedia 
        //         allowedTypes={getAllowedTypes()} 
        //         isSelectable={true} 
        //         handleOnSelect={(original, asset) => {
        //             onAssetNew(asset || {
        //                 image: getFileTypeImageVideo(original) == "image" ? {
        //                     url: original,
        //                     thumbnail: {
        //                         url: original
        //                     }
        //                 } : undefined,
        //                 video: getFileTypeImageVideo(original) == "video" ? {
        //                     url: original
        //                 } : undefined
        //             });
        //             closeModalPriority();
        //         }}
        //         showMyAssets={true} 
        //     />, 1200, true, true
        // );
    }

    const otherAssets = [...allPosts?.filter(p => p.network != post?.network && !!p?.assets?.length)?.map((p) => p?.assets)?.flat()?.filter(a => getAllowedTypes()?.includes(getFileType(a?.image?.url || a?.video?.url)))];

    return (
        <>
            <Dropdown
                placement={placement}
                parentClassName={`w-full ${className}`}
                menuClass="w-auto max-w-[350px] max-h-[400px] overflow-y-auto text-sm"
                portal={portal}
                disabled={!canLoadMoreMedia()}
                renderTitle={(typeof renderTitle === "function" ? renderTitle({ isGenerating, canAddMore: canLoadMoreMedia() }) : renderTitle) || (
                    <Button
                        variant={isGenerating ? "ai" : "filled"}
                        color="tertiary-100"
                        className={`block mt-2 !text-tertiary-700 w-full bg-secondary-300 dark:bg-gray-600 dark:!text-gray-100 ${isGenerating && `!text-white`}`}
                        disabled={!canLoadMoreMedia() || isGenerating}
                        loading={isGenerating}
                    >
                        {isGenerating ? <>Generating asset</> : <>Add asset...</>}
                    </Button>
                )}
            >
                <>
                    {!!otherAssets?.length && <>
                            <Dropdown.Item className="!p-0">
                                <div className="w-full gap-2 !py-1 px-3 flex items-center whitespace-nowrap overflow-x-auto !h-28">
                                    {otherAssets?.map((asset, key) => (
                                        <span
                                            key={asset?.image?.url || asset?.video?.url || key}
                                            onClick={() => handleOnSelectAsset(asset)}
                                            className="group relative inline-block !h-full !shrink-0 !rounded !overflow-hidden cursor-pointer"
                                        >
                                            {getFileTypeImageVideo(asset?.image?.url || asset?.video?.url) == "image" 
                                                ? (
                                                    <img src={asset?.image?.url} className="!h-full !w-auto !rounded" />
                                                ) : (
                                                    <video src={asset?.video?.url} className="!h-full !w-auto !rounded" />
                                                )
                                            }
                                            <div className="w-full h-full left-0 top-0 bg-gray-900/50 z-10 text-white text-2xl flex flex-col items-center justify-center transition-all opacity-0 hover:opacity-100 absolute">
                                                <HiOutlinePlus />
                                            </div>
                                        </span>
                                    ))}
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item variant="divider" />
                        </>}

                        <Dropdown.Item disabled={!getAllowedTypes().find((value) => value == "image")} onClick={handleOnSuggestAIImage} className="group flex items-center justify-between gap-4 lg:gap-8 py-2 px-4">
                            <div className="flex items-center gap-2">
                                <RiImageAiLine className='shrink-0 h-6 md:text-2xl text-pink-500' />
                                <span>Suggest AI-Image</span>
                                {aiImagePrice > 0 && (
                                    <AIPriceBadge
                                        price={aiImagePrice}
                                        quantity={1}
                                        priceType="generation"
                                        size="sm"
                                        variant="pink"
                                        animate={false}
                                    />
                                )}
                            </div>
                            <TbSettings 
                                className="transition-all md:text-xl hover:!opacity-[0.7] opacity-0 group-hover:opacity-100" 
                                onClick={(e) => { e.stopPropagation(); openModalPriority(<AIImages isModal={true} />, 1300); }}
                            />
                        </Dropdown.Item>
                        <Dropdown.Item disabled={!getAllowedTypes().find((value) => value == "video")} onClick={handleOnSuggestAIVideo} className="group flex items-center justify-between gap-4 lg:gap-8 py-2 px-4">
                            <div className="flex items-center gap-2">
                                <RiVideoOnAiLine className='shrink-0 h-6 md:text-2xl text-cyan-500' />
                                <span>Suggest AI-Video</span>
                                {aiVideoPrice > 0 && (
                                    <AIPriceBadge
                                        price={aiVideoPrice}
                                        quantity={1}
                                        priceType="generation"
                                        size="sm"
                                        variant="blue"
                                        animate={false}
                                    />
                                )}
                            </div>
                            <TbSettings 
                                className="transition-all md:text-xl hover:!opacity-[0.7] opacity-0 group-hover:opacity-100" 
                                onClick={(e) => { e.stopPropagation(); openModalPriority(<AIVideos isModal={true} />, 1300); }}
                            />
                        </Dropdown.Item>
                        <Dropdown.Item disabled={!getAllowedTypes().find((value) => value == "image")} onClick={handleOnSuggestStockImage} className="flex items-center gap-2 py-2 px-4">
                            <TbDatabaseStar className='shrink-0 h-6 md:text-2xl text-fuchsia-600' />
                            <span>Suggest Stock Image</span>
                        </Dropdown.Item>
                        <Dropdown.Item disabled={!getAllowedTypes().find((value) => value == "gif")} onClick={handleOnSuggestGIF} className="flex items-center gap-2 py-2 px-4">
                            <TbGif className='shrink-0 h-6 md:text-2xl text-secondary' />
                            <span>Suggest GIF</span>
                        </Dropdown.Item>

                        <Dropdown.Item variant="divider" />

                        <Dropdown.Item onClick={handleOnSelectImage} className="flex items-center gap-2 py-2 px-4">
                            <MdOutlineImageSearch className='shrink-0 h-6 md:text-2xl' />
                            <span>Select/upload asset</span>
                        </Dropdown.Item>
                </>
            </Dropdown>

            <Dialog 
                isOpen={selectAssetModalOpened} 
                onClose={() => setSelectAssetModalOpened(false)} 
                onRequestClose={() => setSelectAssetModalOpened(false)} 
                className="!w-full !max-w-[1200px] lg:!scale-[0.92]"
                overlayClassName="flex items-center justify-center" 
                contentClassName="flex flex-col !h-[90vh] !overflow-hidden !p-4 lg:!p-6 lg:!pb-4"
                portalClassName="!z-[100000000] relative"
                closable={true}
            >
                <div className="flex flex-col flex-1 overflow-hidden">
                    <div className="flex-1 overflow-y-auto">
                        <ExploreMedia 
                            onClose={() => setSelectAssetModalOpened(false)}
                            allowedTypes={getAllowedTypes()} 
                            isSelectable={true} 
                            isMultipleSelect={true}
                            showMyAssets={true} 
                            initialSelectedAssets={
                                post?.assets?.map(asset => ({
                                    originalSrc: asset?.image?.url || asset?.video?.url,
                                    asset: asset
                                }))
                            }
                            handleOnUnselect={(original, asset) => {
                                const newAsset = asset || {
                                    image: getFileTypeImageVideo(original) == "image" ? {
                                        url: original,
                                        thumbnail: {
                                            url: original
                                        }
                                    } : undefined,
                                    video: getFileTypeImageVideo(original) == "video" ? {
                                        url: original
                                    } : undefined
                                };
                                const assetIndex = [...post?.assets?.map(e => e?.image?.url)].findIndex(e => e == newAsset?.image?.url || e == newAsset?.video?.url)
                                onAssetDelete(assetIndex);
                                return true;
                            }}
                            handleOnSelect={(original, asset) => {
                                const newAsset = asset || {
                                    image: getFileTypeImageVideo(original) == "image" ? {
                                        url: original,
                                        thumbnail: {
                                            url: original
                                        }
                                    } : undefined,
                                    video: getFileTypeImageVideo(original) == "video" ? {
                                        url: original
                                    } : undefined
                                };
                                onAssetNew(newAsset);
                                if (!canLoadMoreMedia([...(post?.assets || []), newAsset])) {
                                    setSelectAssetModalOpened(false);
                                }
                                return true;
                            }}
                        />
                    </div>
                    <div className='shrink-0 w-full rounded-b-2xl bottom-0 left-0 right-0 flex justify-end items-center gap-2 pt-4 border-t border-gray-100 dark:border-gray-600 bg-secondary-500 dark:bg-gray-800'>
                        <Button variant="plain" onClick={() => setSelectAssetModalOpened(false)}>Close</Button>
                        <Button variant="solid" onClick={() => setSelectAssetModalOpened(false)}>Confirm</Button>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default AddAssetButton;